export enum SelectedViewsActions {
  SET_SELECTED_VIEW = 'SET_SELECTED_VIEW',
}
